module.exports = __webpack_public_path__ + "img/the rabbits reunion.fe7e3710.png";